import React, { useState } from "react";
import PropTypes from "prop-types";
import StudentList from "../StudentList/StudentList";
import StudentListTableHeader from "../StudentListTableHeader/StudentListTableHeader";
import styles from "./StudentListTable.module.css";

const StudentListTable = ({ 
  students, 
  onCheckboxChange,
  onStatusChange,
  onSelectAll,
  onWatchReportSubmitClick,
  onStudentNameClick,
  view,
  selectedAll,
}) => {

  // const [isChecked, setIsChecked] = useState(selectedAll); // Track the "Select All" checkbox state

  const handleSelectAll = (isChecked) => {
    // setIsChecked(isChecked);  // Update the state when the checkbox is toggled
    onSelectAll(isChecked);   // Call the parent function to update individual checkboxes
  };

  return (
    <div className={styles.container}>
      <StudentListTableHeader
        isChecked={selectedAll}
        onSelectAll={handleSelectAll}
        view={view}
      />
      <div className={styles.listContainer}>
        <StudentList
          students={students}
          onCheckboxChange={onCheckboxChange}
          onStatusChange={onStatusChange}
          onWatchReportSubmitClick={onWatchReportSubmitClick}
          onStudentNameClick={onStudentNameClick}
          view={view}
        />
      </div>
    </div>
  );
};

StudentListTable.propTypes = {
  students: PropTypes.arrayOf(PropTypes.object),
  onCheckboxChange: PropTypes.func,
  onStatusChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onWatchReportSubmitClick: PropTypes.func,
  onStudentNameClick: PropTypes.func,
  view: PropTypes.oneOf(["background", "cpnw"]),
}

export default StudentListTable;